import { render, staticRenderFns } from "./common-report-table.vue?vue&type=template&id=de1a6698&"
import script from "./common-report-table.vue?vue&type=script&lang=js&"
export * from "./common-report-table.vue?vue&type=script&lang=js&"
import style0 from "./common-report-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports